import {
  Component,
  OnInit,
  EventEmitter,
  ElementRef,
  ViewChild,
  Output,
  Input,
  AfterViewInit, Renderer2
} from '@angular/core';
import { UploadFile, UploadInput, UploadOutput, humanizeBytes } from 'ngx-uploader';
import { MessageService } from '../../core/services/message.service';
import { BACKEND_API_URL, IMAGE_BASE__URL } from '../../core/services/CusHttp';

const UPLOAD_URL = BACKEND_API_URL + 'v1/public/upload';

@Component({
  selector: 'app-pictrue-uploader',
  templateUrl: './pictrue-uploader.component.html',
  styleUrls: ['./pictrue-uploader.component.scss']
})
export class PictrueUploaderComponent implements OnInit, AfterViewInit {

  @ViewChild('filePicker') filePicker: ElementRef;
  @ViewChild('selArea') selArea: ElementRef;

  @Input() isComment: boolean = false;    // 是否现实备注信息
  @Input() width: number = 200;           // 图像宽度
  @Input() height: number;          // 图像高度
  @Input() isSquare: boolean = false;     // true：正方形， false：圆形
  @Input() color: string = '#e2e2e2';     // 无图片区域的背景色
  @Input() fontIcon: string = 'fa-user-o fa-3x';
  @Input() fontColor: string = 'white';
  @Input() border: string;
  @Input() src: string;
  @Input() set domainsrc(src: string) {

    this.src = src;
    let reg = /^http/i;
    if (reg.test(src)) {
      this.domain = '';
    } else {
      this.domain = IMAGE_BASE__URL;
    }
  };
  @Output() srcChange: EventEmitter<string>;

  defaultSrc: string = 'assets/images/default-headimg.jpg';
  domain: string = IMAGE_BASE__URL;
  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  dragOver: boolean;
  humanizeBytes: Function;
  validate: boolean = true;

  isLoading: boolean;

  constructor(private renderer: Renderer2, private _msg: MessageService) {
    this.formData = new FormData();
    this.formData.append('concurrency', '1');
    this.formData.append('autoLoad', 'false');
    this.formData.append('verbose', 'true');

    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.srcChange = new EventEmitter<string>();
    this.humanizeBytes = humanizeBytes;

    this.isLoading = false;

  }

  ngOnInit() {

    !this.height && (this.height = this.width);
    // 设置图片的大小尺寸
    this.renderer.setStyle(this.selArea.nativeElement, 'width', this.width + 'px');
    this.renderer.setStyle(this.selArea.nativeElement, 'height', this.height + 'px');
    // 设置背景色
    this.renderer.setStyle(this.selArea.nativeElement, 'background-color', this.color);
    // 设置边框
    this.border && this.renderer.setStyle(this.selArea.nativeElement, 'border', this.border);

    // 设置形状
    !this.isSquare && this.renderer.addClass(this.selArea.nativeElement, 'radius');
    // this.renderer.setElementStyle(this.selArea.nativeElement, 'width.px', this.width.toString());
    // this.renderer.setElementStyle(this.selArea.nativeElement, 'height.px', this.width.toString());
  }

  ngAfterViewInit() {

  }

  getClasses() {
    let cls = {
      'radius': !this.isSquare
    };
    return cls;
  }

  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') { // when all files added in queue

      if (this.validate) {
        const event: UploadInput = {
          type: 'uploadAll',
          url: UPLOAD_URL,
          method: 'POST',
          data: { foo: 'bar' },
          concurrency: this.formData['concurrency']
        };
        this.uploadInput.emit(event);
      }

      // uncomment this if you want to auto upload files when added
      // const event: UploadInput = {
      //   type: 'uploadAll',
      //   url: '/upload',
      //   method: 'POST',
      //   data: { foo: 'bar' },
      //   concurrency: 0
      // };
      // this.uploadInput.emit(event);
    } else if (output.type === 'start') {
      this.isLoading = true;
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added

      let regimg = new RegExp(/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/);
      if (!regimg.test(output.file.name)) {
        this._msg.warn('图片格式不正确。只允许上传jpg,gif,png格式的图片。');
        this.validate = false;
      } else {
        this.validate = true;
        this.files.push(output.file);
      }
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'done') {
      if (this.validate) {
        // console.log("DONE:::", output);
        this.isLoading = false;
        if (output.file && output.file.responseStatus === 200) {
          this._msg.success('上传成功！');
          this.src = output.file.response.data.url;
          this.files = [];
          this.srcChange.emit(this.src);
          setTimeout(() => {
            this._msg.clear();
          }, 3000);
        }
      }


    }
  }

  // when click the picture , choose a new pictrue from the locale disk.
  selectPictrue() {
    this.renderer.selectRootElement(this.filePicker.nativeElement).click();
  }

  // when click upload button
  upload() {
    // console.log(this.files);

  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/pictrue-uploader/pictrue-uploader.component.ts